module.exports = __webpack_public_path__ + "static/img/28.2f848076.png";